import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';

import axios from 'axios';


const DrpProjects = forwardRef((props, ref) => {

    //#region const 

    const [List, setList] = useState([]);
    const [ShowLoader, setShowLoader] = useState(true)
    //#endregion

    //#region Methods 

    useImperativeHandle(ref, () => ({
        Get() {
            var RequestOption = {
                method: "Get",
                url: General.ApiRoute() + "/Project/GetAll",
                headers: {
                    ApiKey: process.env.REACT_APP_APIKEY
                }
            }

            axios(RequestOption)
                .then(function (res) {
                    setList(res.data);
                    setShowLoader(false);
                })
        }
    }))

    const SelectItem = (e) => {
        props.onSelect(e);
    }



    //#endregion


    return (
        <rsuite.SelectPicker
            className="mb-2 w-100"
            loading={ShowLoader}
            data={List}
            labelKey="title"
            valueKey="id"
            value={props.value}
            onSelect={SelectItem}
            disabled={props.disabled}

        />
    );
});

export default DrpProjects;